'use strict';

class PasswordChange {
  constructor(userService, validationService, I18N, Notification) {
    this.userService = userService;
    this.validationService = validationService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  $onInit() {
    this.password = {
      current: null,
      new: null,
      verifyNew: null
    };

    this.userService.get()
      .then((resp) => {
        this.email = resp.data.userName;
      });
  }

  compare() {
    return this.password.new !== this.password.verifyNew;
  }

  update() {
    this.validationService.cleanupErrors();

    if (this.password.current) {
      if (!this.password.new || !this.password.verifyNew) {
        this.validationService.listError('new', 'Påkrevd');
        this.validationService.listError('verifyNew', 'Påkrevd');
      } else if (this.password.current === this.password.new) {
        this.validationService.listError('new', 'Ønsket passord er det samme som gammelt passord');
      } else {
        this.userService.updatePassword(this.password)
          .then(() => {
            this.Notification.success(this.I18N.general.saved);
          })
          .catch((err) => {
            this.validationService.listErrors(err.data.errors);
            this.Notification.error(err.data.endUserMessage);
          });
      }
    } else {
      this.validationService.listError('current', 'Påkrevd');
    }
  }
}

PasswordChange.$inject = ['userService', 'validationService', 'I18N', 'Notification'];

const passwordChange = {
  controller: PasswordChange,
  template: `
    <fieldset ng-form name="passwordChangeForm">
      <h3 class="subheader">Endre passord</h3>

      <div>
        <label for="new">Ønsket passord</label>
        <input type="password" id="new" name="new" ng-model="$ctrl.password.new" maxlength="36" placeholder="minst 8 tegn" required password-validator>
      </div>

      <div>
        <label for="verifyNew">Gjenta ønsket passord</label>
        <input type="password" id="verifyNew" name="verifyNew" ng-model="$ctrl.password.verifyNew" maxlength="36" placeholder="minst 8 tegn" required>
        <span class="error" ng-show="$ctrl.compare()">Passordene stemmer ikke overens</span>
      </div>

      <hr>

      <div>
        <label for="current">Nåværende passord</label>
        <input type="password" id="current" name="current" ng-model="$ctrl.password.current" maxlength="36" placeholder="minst 8 tegn" required>
      </div>

      <button class="button" ng-click="$ctrl.update()" ng-disabled="passwordChangeForm.$invalid">Lagre</button>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('passwordChange', passwordChange);
